import { Injectable } from '@angular/core'
import { Observable, BehaviorSubject, Subscription } from 'rxjs'
import { ErrorhandlingService } from '../_common/errorhandling/errorhandling.service'
//import { RouterParamsService } from '../.common/services/router-params.service';

import { Storage } from 'aws-amplify'
import { API, GraphQLResult, graphqlOperation } from '@aws-amplify/api'

import * as queries from './../../graphql/queries'
import * as mutations from './../../graphql/mutations'
import * as subscriptions from './../../graphql/subscriptions'
import {
    CreateContextchannelInput,
    CreateContextchannelMutation,
    Contextchannel,
    GetClientQuery,
    GetContextchannelQuery,
    ListContextchannelsQuery,
    CreateContextchannelSubscriptionMutation,
    CreateContextchannelLanguagesInput,
    CreateContextchannelLanguagesMutation,
    CreateContextchannelSpeakersMutation,
    CreateContextchannelSpeakersInput,
} from './../../API.service'

@Injectable({
    providedIn: 'root',
})
export class Pia3ContextchannelService {
    private _currentContextchannel: BehaviorSubject<Contextchannel> = new BehaviorSubject(null)
    public readonly currentContextchannel: Observable<Contextchannel> = this._currentContextchannel.asObservable()

    public defaultContextchannelImage: string = 'assets/ui/components/pia-video/PIA3_video_poster.png'

    constructor(private errorHandlerService: ErrorhandlingService) {}

    async getContextchannel(id: string): Promise<{ data: GetContextchannelQuery }> {
        const query = await (API.graphql<Contextchannel>(graphqlOperation(queries.getContextchannel, { id: id })) as Promise<{ data: GetContextchannelQuery }>)
        return query
    }

    async getContextchannelTest() {
        setTimeout(() => {
            //console.log('second')
        }, 6000)
    }

    getContextchannelTestSync() {
        //setTimeout(() => {
        //console.log('second but sync')
        //}, 6000);
    }

    async getContextchannelsForCurrentUser() {
        return API.graphql(graphqlOperation(queries.listContextchannels)) as Promise<{
            data: ListContextchannelsQuery
        }>
    }

    async getContextchannelsForCurrentUserWithImages(): Promise<{
        data: ListContextchannelsQuery
    }> {
        const listContextchannelQueryResult = (await API.graphql<Contextchannel[]>({
            query: queries.listContextchannels,
        })) as Promise<{ data: ListContextchannelsQuery }>

        return listContextchannelQueryResult
        // const contextchannelsWithImages = await Promise.all(
        //   (
        //     await contextchannels
        //   )..map(async (contextchannel) => {
        //     //console.log(contextchannel);
        //     const image = await Storage.get(contextchannel.s3ImageUrl);
        //     contextchannel.s3ImageUrl =
        //       image != null ? image : this.defaultContextchannelImage;
        //     return contextchannel;
        //   })
        // );
        // return contextchannelsWithImages.data.listContextchannels.items;
    }

    async getContextchannelsByClientId(clientId: string) {
        const query = await (API.graphql(graphqlOperation(queries.getClient, { id: clientId })) as Promise<{ data: GetClientQuery }>)
        return query.data.getClient.Contextchannels
    }

    async createContextchannel(input: CreateContextchannelInput) {
        const mutation = await (API.graphql(graphqlOperation(mutations.createContextchannel, { input: input })) as Promise<{ data: CreateContextchannelMutation }>)
        return (await mutation).data.createContextchannel
    }

    async createContextchannelLanguages(input: CreateContextchannelLanguagesInput) {
        const mutation = await (API.graphql(graphqlOperation(mutations.createContextchannelLanguages, { input: input })) as Promise<{ data: CreateContextchannelLanguagesMutation }>)
        return (await mutation).data.createContextchannelLanguages
    }

    async createContextchannelSpeakers(input: CreateContextchannelSpeakersInput) {
        const mutation = await (API.graphql(graphqlOperation(mutations.createContextchannelSpeakers, { input: input })) as Promise<{ data: CreateContextchannelSpeakersMutation }>)
        return (await mutation).data.createContextchannelSpeakers
    }

    async getOnCreateContextchannelsSubscription(next: void, error: void) {
        //const subscription = API.graphql(graphqlOperation(subscriptions.onCreateContextchannel)).subscribe({})
    }

    async getOnUpdateContextchannelsSubscription() {
        // return API.graphql(graphqlOperation(subscriptions.onUpdateContextchannel));
    }

    async getOnDeleteContextchannelsSubscription() {
        // return API.graphql(graphqlOperation(subscriptions.onDeleteContextchannel));
    }

    async subscribeUserToContextchannel(contextchannel: Contextchannel) {
        return API.graphql(graphqlOperation(mutations.createContextchannelSubscription)) as Promise<{
            data: CreateContextchannelSubscriptionMutation
        }>
    }
}
